import Comp from "./ErrorLoading";

export default Comp;
